<template>
    <v-container id="DetalleReporte" style="padding-top: 80px !important" class="pt-5">
        <v-row class="ma-1 ">
            <v-card width="100%" class="mx-2">
                <Menu></Menu>
            </v-card>
        </v-row>
        <v-card elevation="6" class="base-card-container pa-0 mt-4">
            <v-card-title class="primary">
                <v-icon class="pr-4" :color="'#FFFFFF'">mdi-swap-horizontal</v-icon>
                <v-toolbar-title id="titulocard"> Reasignaciones Masivas </v-toolbar-title>
            </v-card-title>
            <v-form ref="form" v-model="validForm" lazy-validation>
                <v-card-text v-if="loaded">
                    <v-row justify="center">
                        <v-col cols="12" md="7">
                            <div>
                                <div class="mt-4">
                                    <span class="type-label-style">Busque al abogado actual: </span>
                                    <v-text-field class="pt-2" v-model="prnombre" label="" outlined dense>
                                    </v-text-field>
                                </div>
                            </div>
                        </v-col>
                        <v-col cols="12" md="8">
                            <div v-if="showprovactual" class="mt-4">
                                <DataTable :url="url" :columns="columnasProveedorAct" :params="displayProveedorAct"
                                    :formatterActions="formatterActions" @apiDT="apiDT = $event" :order="[]">
                                </DataTable>
                            </div>
                        </v-col>
                    </v-row>
                </v-card-text>
                <v-card-text v-if="showreportes">
                    <v-row class="mt-1">
                        <v-col cols="6" md="6" sm="6">
                            <v-btn @click="Regresar()" color="#FF5C93" style="color:white">
                                <v-icon left>
                                    mdi-arrow-left-bold-circle-outline
                                </v-icon>
                                Regresar
                            </v-btn>
                        </v-col>
                        <v-col cols="6" md="6" sm="6" style="display: flex; justify-content: end;">
                            <v-btn @click="Siguiente()" color="#536DFE" style="color:white" :disabled="disSiguiente">
                                Siguiente
                                <v-icon right>
                                    mdi-arrow-right-bold-circle-outline
                                </v-icon>
                            </v-btn>
                        </v-col>
                    </v-row>
                    <v-row justify="center">
                        <v-col cols="12" md="7">
                            <div>
                                <span class="type-label-style">Abogado: </span>
                                <p class="type-text-style">{{ this.prnombrecompleto }}</p>
                            </div>
                        </v-col>
                        <v-col cols="12" md="8">
                            <div v-if="showprovactual" class="mt-4">
                                <DataTable :url="urlReportes" class="tablaEspecial" :columns="columnasProveedorActReportes"
                                    :params="displayProveedorActReportes" @apiDT="apiDT = $event" select="multiple"
                                    :reduce="fila => fila.Reporte" @input="seleccionarReportes" :pCausion="permisoCausion"
                                    :dom="'Bfrtip'" @SeleccionTabla="SeleccionarTodo" :todo="false" :order="[]">
                                </DataTable>
                            </div>
                        </v-col>
                    </v-row>
                </v-card-text>
                <v-card-text v-if="shownuevoproveedor">
                    <v-row class="mt-1">
                        <v-col cols="6" md="6" sm="6">
                            <v-btn @click="RegresarReportes()" color="#FF5C93" style="color:white">
                                <v-icon left>
                                    mdi-arrow-left-bold-circle-outline
                                </v-icon>
                                Regresar
                            </v-btn>
                        </v-col>
                    </v-row>
                    <v-row justify="center">
                        <v-col cols="12" md="7">
                            <div>
                                <span class="type-label-style">Busque al abogado al cual se le asignaran los reportes:
                                </span>
                                <br>
                                <span class="type-label-style">Abogado Actual: </span>
                                <p class="type-text-style">{{ this.prnombrecompleto }}</p>
                                <span class="type-label-style">Reportes: </span>
                                <p class="type-text-style">{{ this.reportes.join() }}</p>
                            </div>
                            <div class="mt-4">
                                <span class="type-label-style">Abogado a asignar: </span>
                                <v-text-field class="pt-2" v-model="prnombrenuevo" label="" outlined dense>
                                </v-text-field>
                            </div>
                        </v-col>
                        <v-col cols="12" md="8">
                            <div v-if="showprovasignar" class="mt-4">
                                <DataTable :url="urlProveecorAsignar" :columns="columnasProveedorAsignar"
                                    :params="displayProveedorAsig" :formatterActions="formatterActionsAsignar"
                                    @apiDT="apiDT = $event" :order="[]"></DataTable>
                            </div>
                        </v-col>
                    </v-row>
                </v-card-text>
            </v-form>
        </v-card>
    </v-container>
</template>

<script>
import { mapMutations, mapState } from 'vuex';
import Menu from '@/components/pages/operacion/MenuEstadisticas/Menu.vue';
import MetodosGenerales from '@/utils/metodosgenerales.vue.js';
import DataTable from "@/components/pages/DataTableNet/DataTable";
import UtilidadesServ from '@/services/Utilidades/Utilidades.service.js';

    export default {
        title() {
            return this.$route.meta.title
        },
    components: {
        Menu,
        DataTable,
        /*JsonExcel,
        xlsxPopulate, */
    },
    data() {
        return {
            validForm: true,
            loaded: true,
            prnombre: '',
            permisoExpJur: false,
            showprovactual: false,
            url: "Utilidades/MostrarProveedorActual",
            apiDT: null,
            displayProveedorAct: {
                prnombre: ''
            },
            columnasProveedorAct: [
                { name: 'Nombre', data: 'prnombre', title: "Nombre", formatter: [this, "proveedorDatos"], },
                { name: 'Supervisoria', data: 'susupervisoria', title: "Supervisoria" },
                { name: 'Gerencia', data: 'genombre', title: "Gerencia" },
                { name: 'Estatus', data: 'prestatus', title: "Estatus" },
            ],
            formatterActions: [
                { click: [this, "ProveedorInfoActual"] },
            ],
            prnombrecompleto: '',
            urlReportes: "Utilidades/MostrarReportesProveedorActual",
            displayProveedorActReportes: {
                prclave: ''
            },
            columnasProveedorActReportes: [
                { name: 'Reporte', data: 'Reporte', title: "Reporte", },
                { name: 'Fecha de Conclusión', data: 'svfhconclusion', title: "Fecha de Conclusión" },
                { name: 'Localidad', data: 'lonombre', title: "Localidad" },
                { name: 'Aseguradora', data: 'clnombrecorto', title: "Aseguradora" },
                { name: 'Caución', data: 'PorRecuperar', title: "Caución" },
            ],
            showreportes: false,
            shownuevoproveedor: false,
            reportes: [],
            prnombrenuevo: '',
            showprovasignar: false,
            displayProveedorAsig: {
                prnombrenuevo: '',
                prclave: ''
            },
            prclaveActual: '',
            urlProveecorAsignar: "Utilidades/MostrarProveedorAsignar",
            columnasProveedorAsignar: [
                { name: 'Nombre', data: 'prnombre', title: "Nombre" },
                { name: 'Supervisoria', data: 'susupervisoria', title: "Supervisoria" },
                { name: 'Gerencia', data: 'genombre', title: "Gerencia" },
                { name: 'Estatus', data: 'prestatus', title: "Estatus" },
                { name: 'Asignar', data: 'prclave', title: "Asignar", formatter: [this, "Asignar"], orderable: false },
            ],
            formatterActionsAsignar: [
                { click: [this, "AsignarProveedor"] },
            ],
            disSiguiente: true,
            permisoReasignaciones: false,
            permisoCausion: false
        }
    },
    computed: {
        ...mapState(["domain", "informationPage", "permission"]),
    },
    watch: {
        'prnombre'(val) {
            if (val.trim().length >= 3) {
                this.BuscarProveedorActual();
            }
        },
        'prnombrenuevo'(val) {
            if (val.trim().length >= 3) {
                this.BuscarProveedorAsignar();
            }
        },
        'reportes'(val) {
            this.disSiguiente = val.length > 0 ? false : true
        }
    },
    async beforeMount() {
        await MetodosGenerales.verificarPermisoSolo(this.domain.domainNameForApi, "VerificarPermiso", '28,47,48').then(response => {
            if (response.data.length > 0) {
                response.data.forEach(permiso => {
                    if (permiso.peclave == 28)//Permiso para ver ExpJur
                        this.permisoExpJur = true;
                    if (permiso.peclave == 47)//Permiso para Reasignaciones
                        this.permisoReasignaciones = true;
                    if (permiso.peclave == 48)//Permiso para Reasignaciones
                        this.permisoCausion = true;
                });
            }
            if (this.permisoExpJur == false || this.permisoReasignaciones == false) {
                this.$router.push({ name: `NoAutorizado` }).catch(error => error);
            }
        });
    },
    methods: {
        ...mapMutations(["changeReporteMenuOption"]),
        reloadTable() {
            if (this.apiDT != null) {
                this.apiDT.ajax.reload(null, false);
                this.apiDT.columns.adjust().responsive.recalc();
            }
        },
        Asignar(datos) {
            return datos.prclave ? `<div><button type="button" class="mr-1 v-btn v-btn--is-elevated v-btn--fab v-btn--has-bg v-btn--round theme--dark v-size--small blue darken-4 dt-formatterAction" aria-haspopup="true" data-action="0" data-params="${datos.prclave}" title="Asignar" aria-expanded="false"><span class="v-btn__content"><i aria-hidden="true" class="v-icon notranslate mdi mdi-account-plus theme--dark"></i></span></button></div>` : ``;
        },
        proveedorDatos(datos) {
            return `<div><button type="button" class="mr-1 dt-formatterAction" aria-haspopup="true" data-action="0" data-params="${datos}" aria-expanded="false"><span class='reporteindice'>${datos.prnombre}</span></button></div>`;
        },
        async BuscarProveedorActual() {
            this.showprovactual = true;
            this.displayProveedorAct = {
                prnombre: this.prnombre
            };
            await this.reloadTable();
        },
        async ProveedorInfoActual(params, item, fila) {
            this.prnombrecompleto = item.prnombre
            this.prclaveActual = item.prclave
            this.loaded = false;
            this.showreportes = true;
            this.displayProveedorActReportes = {
                prclave: item.prclave
            };
            await this.reloadTable();
        },
        seleccionarReportes(reporte) {
            this.reportes = reporte;
        },
        Regresar() {
            this.loaded = true;
            this.showreportes = false;
            this.disSiguiente = true;
        },
        Siguiente() {
            this.showreportes = false;
            this.shownuevoproveedor = true;
        },
        RegresarReportes() {
            this.reportes = [];
            this.prnombrenuevo = '';
            this.showprovasignar = false;
            this.shownuevoproveedor = false;
            this.showprovactual = true;
            setTimeout(() => {
                this.showreportes = true;
            }, 500);
        },
        async BuscarProveedorAsignar() {
            this.showprovasignar = true;
            this.displayProveedorAsig = {
                prnombrenuevo: this.prnombrenuevo,
                prclave: this.prclaveActual
            };
            await this.reloadTable();
        },
        SeleccionarTodo(tipo) {
            if (tipo == 1) {
                const rows = this.apiDT.rows({ page: 'current' });
                rows.select();
                if (this.permisoCausion == false) {
                    this.apiDT.rows('.blocked-row').deselect();
                }
            } else if (tipo == 2) {
                const rows = this.apiDT.rows({ page: 'current' });
                rows.deselect();
            } else if (tipo == 3) {
                const rows = this.apiDT.rows({ page: 'current' });
                rows.every(function () {
                    if (this.nodes().to$().hasClass('selected')) {
                        this.deselect();
                    } else {
                        this.select();
                    }
                });
                this.apiDT.rows('.blocked-row').deselect();
            }
        },
        async AsignarProveedor(params, datos, fila) {
            this.$swal({
                title: 'Reasignando reporte(s), espere, por favor.',
                allowEscapeKey: false,
                allowOutsideClick: false,
                didOpen: async () => {
                    this.$swal.showLoading();
                    var formData = new FormData();
                    formData.append("reportes", this.reportes.join());
                    formData.append("oldprclave", this.prclaveActual);
                    formData.append("oldprnombre", this.prnombrecompleto);
                    formData.append("newprclave", datos.prclave);
                    formData.append("newprnombre", datos.prnombre);
                    let response = await UtilidadesServ.AltaReasignacion(formData);
                    if (response == true) {
                        this.$swal({
                            position: 'center',
                            icon: 'success',
                            title: 'Éxito',
                            text: 'Se realizó con éxito la reasignación de los reportes',
                            showConfirmButton: true,
                            confirmButtonColor: '#536DFE',
                            confirmButtonText: 'Aceptar',
                            allowOutsideClick: false,
                            timer: 3000
                        }).then(async () => {
                            this.$router.push({ name: `Menu` });
                        });
                    }
                }
            });
        }
    }
}
</script>

<style>
.tablaEspecial div.dt-buttons {
    float: right;
}

.tablaEspecial div.dataTables_wrapper div.dataTables_filter {
    text-align: left;
}

.tablaEspecial .dataTables_wrapper .dataTables_filter {
    float: left;
    text-align: left;
}
</style>